// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"9cd22f77","24":"cab4322c","192":"03b572ca","282":"961bd829","519":"48f5cf29","598":"528a8a97","602":"85a68e62","608":"59b5f232","683":"a766ad87","720":"506005ef","793":"c9af4973","838":"faf81495","892":"9b0c132a","929":"f9ec9073","972":"0de3b0b0"}[chunkId] + ".chunk.js";
};